





























































import { Component, Prop, Vue } from "vue-property-decorator";
import ComponentType from "@/enums/ComponentType";

@Component
export default class ComponentsSidebar extends Vue {
  private ComponentType = ComponentType;

  private dragstartHandler(event: any) {
    this.$emit(
      "setCurrentDragTemplate",
      event.target.getAttribute("componentType")
    );
    event.dataTransfer.setData("text/plain", null);
  }

  private dragHandler(event: any) {
    console.log("dragging");
  }
}
